module.exports = __webpack_public_path__ + "static/media/portfolioLogo.1b96385c.JPG";